import { useState } from "react";
import SignIn from "../SignIn/SignIn";
import SignUp from "../SignUp/SignUp";
import ForgetPassword from "../ForgetPassword/ForgetPassword";

const MainAuthPage = () => {
  const [changeFormPage, setChangeFormPage] = useState("signin");

  return (
    <>
      <div className="w-full h-screen lg:py-0 py-10 bg-mainBackground">
        <div className="bglog-in-wallpaper bg-cover w-full h-full">
          <div className="flex justify-center items-center w-full h-full">
            {/* Sign In Component */}
            {changeFormPage === "signin" && (
              <SignIn
                changeFormPage={changeFormPage}
                setChangeFormPage={setChangeFormPage}
              />
            )}
            {/* Sign Up Component */}
            {changeFormPage === "signup" && (
              <SignUp
                changeFormPage={changeFormPage}
                setChangeFormPage={setChangeFormPage}
              />
            )}
            {/* Sign Up Component */}
            {changeFormPage === "forgetPassword" && (
              <ForgetPassword
                changeFormPage={changeFormPage}
                setChangeFormPage={setChangeFormPage}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default MainAuthPage;
